import { contentZh } from './zh';
import { contentEn } from './en';

export type Locale = 'zh' | 'en';

export interface NavItem {
  label: string;
  href: string;
}

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface PlatformDownload {
  id: 'windows' | 'macos' | 'android' | 'ios';
  name: string;
  href: string;
  clients: string[];
  requirements: string;
  steps: string[];
  troubleshooting: { issue: string; fix: string }[];
}

export interface HelpArticle {
  id: string;
  title: string;
  category: string;
  body: string;
}

export interface PricingPlan {
  name: string;
  price: string;
  period: string;
  features: string[];
  highlighted?: boolean;
}

export interface PublicContent {
  nav: NavItem[];
  footer: {
    product: NavItem[];
    support: NavItem[];
    company: NavItem[];
  };
  common: {
    login: string;
    register: string;
    getStarted: string;
    learnMore: string;
    relatedLinks: string;
    home: string;
    signInForLivePricing: string;
    contactSupport: string;
  };
  landing: {
    heroTitle: string;
    heroHighlight: string;
    heroSubtitle: string;
    featuresTitle: string;
    featuresSubtitle: string;
    howItWorksTitle: string;
    howItWorksSubtitle: string;
    steps: { title: string; description: string }[];
    testimonialsTitle: string;
    testimonialsSubtitle: string;
    testimonials: { content: string; author: string; role: string }[];
    ctaTitle: string;
    ctaSubtitle: string;
    faqTitle: string;
    faqSubtitle: string;
    faqs: FaqItem[];
    platformTitle: string;
    features: { name: string; description: string }[];
  };
  pricing: {
    title: string;
    subtitle: string;
    plans: PricingPlan[];
    comparisonTitle: string;
    comparisonRows: { feature: string; basic: string; standard: string; premium: string }[];
    note: string;
  };
  features: {
    title: string;
    subtitle: string;
    sections: { title: string; description: string }[];
    scenarios: { title: string; description: string }[];
  };
  download: {
    title: string;
    subtitle: string;
    importTitle: string;
    importSteps: { client: string; steps: string[] }[];
    platforms: { id: string; name: string; description: string }[];
  };
  help: {
    title: string;
    subtitle: string;
    faqs: FaqItem[];
    articles: HelpArticle[];
  };
  about: {
    title: string;
    subtitle: string;
    sections: { title: string; content: string }[];
  };
  privacy: {
    title: string;
    sections: { title: string; content: string }[];
  };
  terms: {
    title: string;
    sections: { title: string; content: string }[];
  };
  platforms: Record<'windows' | 'macos' | 'android' | 'ios', PlatformDownload>;
}

export function getContent(locale: Locale): PublicContent {
  return locale === 'en' ? contentEn : contentZh;
}
